import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Vue from 'vue';
import uploader from "lib/mixins/uploader";
export default {
  mixins: [uploader],
  props: {
    IsUpload: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      docId: "",
      sourceFiles: [],
      materialids: [],
      dialogVisiblePreviewResources: false,
      imgsList: [],
      imgUrl: "",
      indexCount: 0
    };
  },
  created: function created() {},
  methods: {
    uploadFile: function uploadFile() {},
    dialogClose: function dialogClose() {},
    fileLimit: function fileLimit() {
      this.$message.warning("一次最多上传8个文件");
    },
    beforeUpload: function beforeUpload(file) {
      var ext = file.name.split('.').pop();
      return ['jpg', 'jpeg', 'png', 'gif', 'doc', 'docx', 'txt', 'xls', 'xlsx', 'pdf'].includes(ext) && this.addFile(file);
    },
    onRemoveHandler: function onRemoveHandler(file) {},
    beforeRemove: function beforeRemove(file, fileList) {},
    handlePreview: function handlePreview(file) {},
    onSuccessHandler: function onSuccessHandler(res, file, uploadFiles) {
      var that = this;
      this.$http.post("/api/XOrg/AttestationActivity/getScreenCourseWareInfo", {
        courseWareId: res.docId
      }).then(function (rst) {
        var data = []; // 判断是否是单张图片

        if (rst.category != "jpg" && rst.category != "jpeg" && rst.category != "png" && rst.category != "gif") {
          var imgs = [];
          var statusUrl = rst.urls.preview_oss_gen; // 拼接图片的地址

          for (var i = 0; i < rst.args_page_count; i++) {
            data.push(statusUrl + (i + 1) + ".png");
          }
        } else {
          data = [res.docPath];
        }

        that.sourceFiles.push({
          title: res.fileName,
          url: data,
          status: rst.status
        });
        console.log(that.sourceFiles);
      });
      this.IsShowUpload = false; // 执行mixins里的onSuccess, 继续下一个文件

      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }

      if (res.code > 0) {
        file.url = res.docPath;
      }

      this.materialids.push(res.docId);
      this.$emit("done", this.materialids);
    },
    see: function see(url, status) {
      if (status == 1) {
        this.dialogVisiblePreviewResources = true;
        this.imgsList = url;
        this.imgUrl = url[0];
      } else {
        this.$message.warning("文件正在转换，请稍等");
      }
    },
    pre: function pre() {
      if (this.indexCount > 0) {
        this.indexCount -= 1;
        this.imgUrl = this.imgsList[this.indexCount];
      }
    },
    next: function next() {
      if (this.indexCount < this.imgsList.length) {
        this.indexCount += 1;
        this.imgUrl = this.imgsList[this.indexCount];
      }
    }
  }
};